import { Fragment } from 'react';
import { SafeMarkdown } from '../../components/SafeMarkdown.js';
function label(key: string) {
  const words = key.replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/[_-]+/g, ' ');
  return words.charAt(0).toUpperCase() + words.slice(1);
}
function WorldValue({ value }: { value: unknown }) {
  if (value === null || value === undefined) return <>Not specified</>;
  if (typeof value === 'string') return <SafeMarkdown content={value || 'Not specified'} />;
  if (typeof value === 'boolean') return <>{value ? 'Yes' : 'No'}</>;
  if (typeof value === 'number') return <>{value.toLocaleString()}</>;
  if (Array.isArray(value))
    return value.length ? (
      <ul>
        {(value as unknown[]).map((item, i) => (
          <li key={i}>
            <WorldValue value={item} />
          </li>
        ))}
      </ul>
    ) : (
      <>None recorded</>
    );
  if (typeof value === 'object')
    return (
      <dl>
        {Object.entries(value as Record<string, unknown>).map(([key, item]) => (
          <Fragment key={key}>
            <dt>
              <strong>{label(key)}</strong>
            </dt>
            <dd>
              <WorldValue value={item} />
            </dd>
          </Fragment>
        ))}
      </dl>
    );
  return null;
}
export function WorldSituation({ world }: { world: Record<string, unknown> }) {
  const { status, ...details } = world;
  return (
    <section aria-label="Current situation">
      <h3>Current situation</h3>
      {status !== undefined && <WorldValue value={status} />}
      {Object.keys(details).length > 0 && <WorldValue value={details} />}
      {Object.keys(world).length === 0 && <p>No world update has been published yet.</p>}
    </section>
  );
}
